// extracted by mini-css-extract-plugin
export default {"container":"C8-z","productName":"D8-z","price":"E8-z","dimensions":"F8-z"};